import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { ChevronRight, Menu, X } from "lucide-react";
import SkyClear from "../../img/SkyClear.png";

export default function WelcomeScreen() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [trustLevel, setTrustLevel] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTrustLevel((prev) => (prev < 100 ? prev + 1 : 0));
    }, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white overflow-hidden">
      <header className="p-4 flex justify-between items-center">
        <nav className="hidden md:block"></nav>
        <button
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X /> : <Menu />}
        </button>
      </header>

      {isMenuOpen && (
        <motion.nav
          initial={{ opacity: 0, x: "100%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "100%" }}
          className="fixed inset-y-0 right-0 w-64 bg-gray-800 p-4"
        >
          <ul className="space-y-4">
            {["Home", "Features", "About", "Contact"].map((item) => (
              <motion.li
                key={item}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
              >
                <a
                  href="#"
                  className="block hover:text-blue-300 transition-colors"
                >
                  {item}
                </a>
              </motion.li>
            ))}
          </ul>
        </motion.nav>
      )}

      <main className="container mx-auto px-4 py-0 relative flex h-full">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="w-1/4 flex flex-col items-center justify-center"
        >
          <div className="relative w-64 h-64 mb-4">
            <svg className="w-full h-full" viewBox="0 0 120 120">
              <circle
                cx="60"
                cy="60"
                r="55"
                fill="none"
                stroke="#4B5563"
                strokeWidth="10"
              />
              <motion.circle
                cx="60"
                cy="60"
                r="55"
                fill="none"
                stroke="#3B82F6"
                strokeWidth="10"
                strokeLinecap="round"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: trustLevel / 100 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
                style={{ rotate: -90, transformOrigin: "center" }}
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <img
                src={SkyClear}
                alt="SkyClear Logo"
                className="w-40 h-40 object-contain"
              />
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
          className="w-3/4 flex items-center justify-center"
        >
          <h2 className="text-4xl md:text-6xl font-extrabold text-center">
            Bienvenidos al sistema
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-500">
              {" Skyangel Clear"}
            </span>
          </h2>
        </motion.div>
      </main>

      <div className="ml-8">
        <h3 className="text-3xl font-bold mb-2">
          Construyendo valor para tu empresa
        </h3>
      </div>

      {/* Burbujas animadas */}
      <motion.div
        className="absolute top-0 left-0 w-full h-[90vh] pointer-events-none overflow-hidden"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.1 }}
        transition={{ duration: 1 }}
      >
        {[...Array(20)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute bg-white rounded-full"
            style={{
              width: Math.random() * 20 + 5,
              height: Math.random() * 20 + 5,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, Math.random() * 100 - 50],
              opacity: [0.7, 0],
            }}
            transition={{
              duration: Math.random() * 5 + 5,
              repeat: Infinity,
              repeatType: "reverse",
            }}
          />
        ))}
      </motion.div>
    </div>
  );
}
